import React,{useEffect, useState} from 'react'
import './css/Annonce.css'
import {auth,data} from './firebase';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import MailOutlineSharpIcon from '@material-ui/icons/MailOutlineSharp';
import PhoneIcon from '@material-ui/icons/Phone';
import { useStateValue } from './StateProvider';

function Reglages() {
        const [{user},dispatch]=useStateValue();
        const [userdata,setUserData]=useState([]);
            useEffect(()=>{
                data.collection("Users").doc(user.uid).onSnapshot(y=>(
                    setUserData(y.data())
                ))
            },[])
        const [state, setState] = useState({
            Prénom: "",
            Téléphone: "",
            city: ""
        });
        
        const handleChange = e => {
            setUserData({
            [e.target.name]: e.target.value
            });
            setState({
                ...state,
            [e.target.name]: e.target.value
            });
        };

        function send(e){
            e.preventDefault();
            if(!state.Prénom==""){
                data.collection("Users").doc(user.uid).update({Prénom:state.Prénom})
            }
            if(!state.Téléphone==""){
                data.collection("Users").doc(user.uid).update({Téléphone:state.Téléphone})
            }
            if(!state.city==""){
                data.collection("Users").doc(user.uid).update({city:state.city})
            }
        }
        
        return (
        <div className="body">
            <button>
                <SettingsOutlinedIcon className="icon"/>
                <p>Réglages</p>
            </button>
            
            <form>
                <select name="filtersList" class="s">
                    <option value="SETTINGS">Modifier vos informations </option>
                    <option value="PASSWORD">Modifier le mot de passe </option>
                </select>
                <ExpandMoreIcon className="icon i2"/>
            </form>
            <form className="form2">
                    <div>
                        <AccountCircleIcon className="iconz"/>
                        <label for="Prénom">Prénom</label>
                        <input type="text" id="Prénom" name="Prénom" placeholder="Prénom" value={userdata.Prénom} onChange={handleChange}/>
                    </div>
                    <div>
                        <PhoneIcon className="iconz"/>
                        <label for="Téléphone">Téléphone</label>
                        <input type="text" id="Téléphone" name="Téléphone" placeholder="Téléphone" value={userdata.Téléphone} onChange={handleChange}/>
                    </div>
                    <div className="last_input">
                        <MailOutlineSharpIcon className="iconz"/>
                        <label for="email">Email</label>
                        <input type="email" id="email" name="email" value={userdata.email} readOnly/>
                    </div>
                    
                    <div className="k">
                        <input type="checkbox" id="Tél" name="Tél" value="Tél" />
                        <label for="Tél">Afficher mon numéro de téléphone</label>
                    </div>
                    
                <p>Vous ne pouvez pas changer votre adresse e-mail. Lisez les questions les plus fréquemment posées</p>
                <label for="city">Vilee</label>
                <select name="city" id="city" className="ss" value={userdata.city} onChange={handleChange}>
                        <option value="3" selected="">Tout le Maroc</option>
                        <option value="Casablanca" > Casablanca</option>
                        <option value="Casablanca"> Grand Casablanca</option>
                        <option style={{backgroundColor: "#dcdcc3", fontWeight:"bold"}}value="0" disabled="disabled">-- AUTRES VILLES --</option>
                        <option id="searcharea_expanded_fisrt_option" value="Ain Harrouda"> Ain Harrouda </option>
                        <option value="Bouskoura"> Bouskoura </option>
                        <option value="Mediouna"> Mediouna </option>
                        <option value="Mohammedia"> Mohammedia </option>
                        <option value="Nouaceur"> Nouaceur </option>
                        <option value="Tamaris"> Tamaris </option>
                        <option value="El Majjatia Ouled Taleb"> El Majjatia Ouled Taleb </option>
                        <option value="Lahraouyine"> Lahraouyine </option>
                        <option value="Sidi Hajjaj Oued Hassar"> Sidi Hajjaj Oued Hassar </option>
                        <option value="Tit Mellil"> Tit Mellil </option>
                        <option value="Dar Bouazza"> Dar Bouazza </option>
                        <option value="Errahma"> Errahma </option>
                        <option value="Lamkansa"> Lamkansa </option>
                        <option value="Oulad Salah"> Oulad Salah </option>
                        <option value="Béni Yakhlef"> Béni Yakhlef </option>
                        <option value="Chellalate"> Chellalate </option>
                        <option value="Sidi Moussa Ben Ali"> Sidi Moussa Ben Ali </option>
                        <option value="Sidi Moussa El Majdoub"> Sidi Moussa El Majdoub </option>
                    </select>
                <div className="ico">
                    <input type="submit" value="CONFIRMER" onClick={send}/>
                </div>
            </form>
        </div>
    )
}

export default Reglages
